export default {
  "card": "_card_1gulc7",
  "plan": "_plan_1gulc7"
};